import { Badge } from "antd";
import { CATEGORY } from "../../domain/notes.domain";

type Props = {
  category_type?: number;
  isBadge?: boolean;
};

export default function CategoryType({ category_type, isBadge = false }: Props) {
  const style = { color: "#1E3A8A", fontSize: "14px", fontWeight: "500" };
  if (category_type === CATEGORY.INDIVIDUAL)
    return isBadge ? (
      <Badge count={"Individual"} showZero className="badge-default" />
    ) : (
      <span style={style}>Individual</span>
    );
  else if (category_type === CATEGORY.RELATIONSHIP)
    return isBadge ? (
      <Badge count={"Relationship"} showZero className="badge-default" />
    ) : (
      <span style={style}>Relationship</span>
    );
  else if (category_type === CATEGORY.FAMILY)
    return isBadge ? <Badge count={"Family"} showZero className="badge-default" /> : <span style={style}>Family</span>;
  else if (category_type === CATEGORY.GROUP)
    return isBadge ? <Badge count={"Group"} showZero className="badge-default" /> : <span style={style}>Group</span>;
  else return <></>;
}
